import React from "react";
import "./NoData.scss";
import NoDataProps from "./NoData.types";
import SVG from "../SVG/SVG";

const NoData = (props: NoDataProps) => {
  const { img, size = "medium", text = "Sunrise Text" } = props;
  const commonNoDataProp = {
    ...props,
    className: ` img--${size} `,
  };
  return (
    // <button {...commonNoDataProp}>{children}</button>;
    <div className="noData_wrapper">
      <div {...commonNoDataProp}>
        <div className="no_data_image">
          <SVG type={props.img} />
        </div>
        <div className="no_data_text">
          <p>{text}</p>
        </div>
      </div>
    </div>
  );
};

export default NoData;
